import { T } from "../../app/tokens.js";

const clamp = { minWidth: 0, overflow: "hidden", display: "-webkit-box", WebkitBoxOrient: "vertical", WebkitLineClamp: 2 };
export function PropertyFact({ label, text, children, testId }) {
  return <div data-testid={testId} style={{ minWidth: 0 }}>
    <div style={{ fontSize: T.fsXs, color: T.mid, marginBottom: 3 }}>{label}</div>
    <div title={text || undefined} tabIndex={text ? 0 : undefined} style={{ ...(text ? clamp : { minWidth: 0 }), fontSize: T.fsBase, color: T.dark, fontWeight: T.fwSemibold }}>
      {children ?? text}
    </div>
  </div>;
}
export const propertyChip = { minWidth: 110, padding: "6px 10px", borderRadius: 10, background: T.hoverBg, border: `1px solid ${T.border}` };
export const propertyLink = { display: "block", width: "100%", minWidth: 0, textAlign: "left", padding: "10px 12px",
  border: `1px solid ${T.border}`, borderRadius: 10, background: T.card, color: T.blue, font: "inherit", cursor: "pointer" };
export function planTargetMonth(value) {
  const iso = String(value ?? "").slice(0, 10);
  const [y, m, d] = iso.split("-").map(Number);
  return y && m && d ? new Date(y, m - 1, d).toLocaleDateString("en-US", { month: "short", year: "numeric" }) : null;
}
